import { render } from "./SendActivation.vue?vue&type=template&id=3208d0ca"
import script from "./SendActivation.vue?vue&type=script&lang=js"
export * from "./SendActivation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__